import { createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL } from "@admin/utils/constants";
import { MessageResponse, User } from "@admin/types";
import { customAxios } from "@admin/utils";

interface LoginResponse {
  token: string;
  user: User;
}

interface LoginRequest {
  email: string;
  password: string;
}

export const login = createAsyncThunk<
  LoginResponse,
  LoginRequest,
  { rejectValue: string }
>("auth/login", async ({ email, password }, { rejectWithValue }) => {
  try {
    const response = await customAxios.post(`${BASE_URL}/auth/login`, {
      email,
      password,
    });
    if (response.data.user.role == "customer") {
      return rejectWithValue("User doesn't have the right roles");
    }
    return response.data;
  } catch (error) {
    let message = "Server error occurred.";
    if (error.response.status === 422) {
      if (error.response.data.errors.email)
        message = error.response.data.errors.email[0];
      else if (error.response.data.errors.password)
        message = error.response.data.errors.password[0];
      else message = "Invalid credentials";
    } else if (error.response.status === 401) {
      message = "Invalid credentials.";
    }
    return rejectWithValue(message);
  }
});

export const sendLoginLink = createAsyncThunk<
  MessageResponse,
  string,
  { rejectValue: string }
>("auth/magic-link", async (email, { rejectWithValue }) => {
  try {
    const response = await customAxios.post(`${BASE_URL}/auth/magic-link`, {
      email,
    });
    return response.data;
  } catch (error) {
    let message = "Server error occurred.";
    if (error.response.status === 422) {
      if (error.response.data.errors.email)
        message = error.response.data.errors.email[0];
      else message = "Invalid credentials";
    }
    return rejectWithValue(message);
  }
});

export const logout = createAsyncThunk<void, void, { rejectValue: string }>(
  "auth/logout",
  async (_, { rejectWithValue }) => {
    try {
      await customAxios.post(`${BASE_URL}/auth/logout`);
      return;
    } catch (_) {
      return rejectWithValue("Logout failed!");
    }
  }
);
